// extracted by mini-css-extract-plugin
export default {"lensLauncher":"LensLauncher_lensLauncher__tWr79"};